export default {
  // See https://github.com/formatjs/formatjs/issues/553#issuecomment-236048104
  SUBMISSION_FORM_ASSET_MIN: 'You must submit at least {count, plural, one {# asset} other {# assets}} per module',
  SUBMISSION_FORM_ASSET_MAX: 'You cannot submit more than {count, plural, one {# asset} other {# assets}} per module',
};